import type { ReactNode } from 'react';
import { Lock } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useOrganization } from '@/hooks/useOrganization';
import { resolvePlan, planAllows } from '@/lib/plans';

interface FeatureGateProps {
  feature: string; // clave de src/lib/plans.ts (vfx, mapa, rodaje, localizaciones…)
  children: ReactNode;
}

// Candado por FEATURE (no por plan): usa el featureSet del plan del org. Si la
// feature está capada, muestra un candado con CTA de upgrade. Enforcement real de
// las rutas (el sidebar solo las esconde; esto bloquea el acceso directo por URL).
export default function FeatureGate({ feature, children }: FeatureGateProps) {
  // Mismo criterio que PlanGate y que el backend: manda la organización DUEÑA del
  // proyecto abierto (?job=), y sin proyecto la organización propia.
  const [searchParams] = useSearchParams();
  const { data: org } = useOrganization(searchParams.get('job'));
  const featureSet = resolvePlan(org?.plan).featureSet;

  if (planAllows(featureSet, feature)) return <>{children}</>;

  return (
    <div className="flex items-center justify-center min-h-[60vh] px-4">
      <Card className="max-w-md w-full border-pelip-border bg-pelip-bg-elev">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-3">
            <Lock size={32} className="text-pelip-text-faint" />
          </div>
          <CardTitle className="text-lg text-pelip-text">Herramienta de producción</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-sm text-pelip-text-muted leading-relaxed">
            Esta herramienta está disponible en los planes <strong>Productora</strong>, <strong>Estudio</strong> y el pase <strong>One Shot</strong>.
            Tu plan actual se centra en el desarrollo creativo del proyecto.
          </p>
          <Button asChild className="w-full">
            <Link to="/plan">Ver planes y mejorar</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
